import React, { useContext, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Upload,
} from "antd";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import OverwriteMomentBE from "../common/datePicker/overwriteMomentBE";
import moment, { Moment } from "moment";
import { VerifyContext } from "../../pages/verification/verify";
import verifyService from "../../services/verify.service";
import Swal from "sweetalert2";

const BtnSendVerify = ({ curri }: { curri: any }) => {
  const [reportDay, setReportDay] = useState<Moment | null>(moment());
  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  const { form, setReCheck } = useContext<any>(VerifyContext);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [antForm] = Form.useForm();

  // Isra Sankaew สิ่งที่ต้องเก็บ
  // ระบุข้อมูล
  // 1.วันที่ส่ง
  // 2.จำนวนรายวิชาที่เปิดสอนในหลักสูตรทั้งหมด
  // 3.จำนวนรายวิชาที่ทวนสอบ
  // 4.คิดเป็นร้อยละ

  ///ส่วนของปี กับเทอมถูกเลือกตั้งแต่แรกอยู่แล้วควนจะมีค่า defualt ไว้เลย หรืออาจจะซ่อนไว้ก็ได้

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const type = form.type === "มคอ." ? "tqf" : "mhesi";
  const onFinish = async (values: any) => {
    const { sendBy, open, verify } = values;
    const playload = {
      year: +form.year,
      type,
      curriculum: curri.id,
      sendBy,
      pathFile: values.upload[0].response.filename,
      report: reportDay === null ? "" : reportDay.format("YYYY/MM/DD"),
      open,
      verify,
      percentage: values.percentage,
      //ที่เหลือข้อมูลมาจาก form
    };
    await verifyService.send(playload).then(() => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "บันทึกสำเร็จ",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        handleClose();
        setReCheck(true);
      });
    });
    setReCheck(false);
  };

  const propsUploadSummary = {
    name: "file",

    //ยิงไปที่อัพโหลดของ ทวนสอบ
    action: `${BaseURL.BASE_URL}/upload/verify/${type}`,
    onChange: (info: any) => {
      return info;
    },
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={handleShow}
      >
        <i className="bi bi-cloud-arrow-up-fill"></i> ส่งผลการทวนสอบ {}
      </button>
      <Modal
        visible={show}
        onCancel={handleClose}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={antForm.submit}
          >
            เพิ่มข้อมูล
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => antForm.resetFields()}
          >
            ล้าง
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleClose}
          >
            Close
          </button>,
        ]}
        // centered
      >
        <h5>ส่งผลการทวนสอบประจำปีการศึกษา : {form.year}</h5>
        <h6>หลักสูตร :</h6>
        <h6>{curri.name}</h6>
        <Form
          name="basic"
          form={antForm}
          initialValues={{
            sendBy: `${user.firstName} ${user.lastName}`,
            date: null,
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row className="mt-4">
            <Col span={24}>
              <p className="text-danger">
                อัพโหลดได้เฉพาะไฟล์ PDF และอัพโหลดได้เพียง 1 ไฟล์เท่านั้น
              </p>
              <Form.Item
                name="upload"
                label={`ไฟล์ผลการทวนสอบ`}
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: "upload เอกสารด้วยครับ!" }]}
              >
                <Upload {...propsUploadSummary} maxCount={1}>
                  <Button>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                <div>
                  <label htmlFor="doc3" className="form-label">
                    วันที่รายงาน
                  </label>
                  <DatePicker
                    // id="doc3"
                    name="date"
                    className={`form-control`}
                    format="DD/MM/YYYY"
                    value={reportDay}
                    onChange={(value) => {
                      setReportDay(value);
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col span={24}>
              <Form.Item
                name={"open"}
                label="จำนวนรายวิชาที่เปิดสอน"
                className="col-12"
                rules={[
                  {
                    required: true,
                    message: "กรุณาระบุจำนวนรายวิชาที่เปิดสอนด้วยครับ",
                  },
                ]}
              >
                <InputNumber min={0} className="col-3" />
              </Form.Item>
            </Col>
          </Row>
          <Row className="">
            <Col span={24}>
              <Form.Item
                name={"verify"}
                label="จำนวนรายวิชาที่ทวนสอบ"
                className="col-12"
                rules={[
                  {
                    required: true,
                    message: "กรุณาระบุจำนวนรายวิชาที่ทวนสอบด้วยครับ",
                  },
                ]}
              >
                <InputNumber min={0} className="col-3" />
              </Form.Item>
            </Col>
          </Row>
          <Row className="">
            <Col span={24}>
              <Form.Item
                name={"percentage"}
                label="คิดเป็นร้อยละ"
                className="col-12"
                rules={[
                  {
                    required: true,
                    message: "กรุณาระบุร้อยละของรายวิชาที่ทวนสอบด้วยครับ",
                  },
                ]}
              >
                <InputNumber min={0} className="col-3" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <label htmlFor="sendBy">ผู้ส่งเอกสาร 3</label>
              <Form.Item
                name="sendBy"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default BtnSendVerify;
